import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import useMedia from "use-media";
import commonUtil from "../../../common/commonUtil";
import CommonValidation from "../../../common/commonValidation";
import { apiKeyCheck, versionGetApi } from "../../../const";
import { getClauseList, getPropertyList, getTempReserveInfo } from '../../../const/RTCC';
import MessageConst from '../../../const/RTCC/messageConst';
import { useRtoaster } from "../../../hooks/useRtoaster";
import common from '../../../resources/RTCC/js/common/common';
import { Button } from "../../atoms/RTCC/button";
import { Label } from '../../atoms/RTCC/label';
import { Line } from '../../atoms/RTCC/line';
import { AcceptForm } from '../../molecules/RTCC/acceptForm';
import { BreadCrumb } from '../../molecules/RTCC/breadCrumb';
import { ErrorMassage } from "../../molecules/RTCC/errorMassage";
import { HumanInputForm } from '../../molecules/RTCC/humanInputForm';
import { RadioButtonForm } from "../../molecules/RTCC/radioButtonForm";
import { RoomInputList } from "../../molecules/RTCC/roomInputList";
import { FooterContainer } from '../../organisms/RTCC/footerContainer';
import './../../../resources/RTCC/css/userInput/userInput.css';

const human = [
    { id: "0", value: "0", selected: true },
    { id: "1", value: "1", selected: false },
    { id: "2", value: "2", selected: false },
    { id: "3", value: "3", selected: false },
];
const represent = [
    { checked: false, value: "represent" }
];

const RtccUserInputContainer = (props) => {
    const {
        state,
        login,
        checkIn,
        checkOut,
        customerAge,
        toUserInputInfo,
        propertyInfo,
        searchParam,
        feeInfo,
        setFeeInfo,
        stayInfo,
        setToUserInputInfo,
        toUserInputConfirmInfo,
        setToUserInputConfirmInfo,
        setPropertyInfo,
        onClickOpenReservationPopupWindow,
        onChange } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const history = useHistory();
    const store = useStore();
    const loginUserInfo = store.getState().login.loginUserInfo;
    const [linkList, setLinkList] = useState([]);
    const [roomNum, setRoomNum] = useState(toUserInputInfo.roomNum);
    const [representInfo, setRepresentInfo] = useState(
        state.locationInfo && state.locationInfo.pathname.indexOf("userInputConfirm") != -1 &&
            toUserInputConfirmInfo.representInfo ?
            toUserInputConfirmInfo.representInfo :
            {
                representName: (loginUserInfo.memberSei ? loginUserInfo.memberSei : "") + (loginUserInfo.memberMei ? loginUserInfo.memberMei : ""),
                representNameKana: (loginUserInfo.memberSeiKana ? loginUserInfo.memberSeiKana : "") + (loginUserInfo.memberMeiKana ? loginUserInfo.memberMeiKana : ""),
                representLastNamePassport: "",
                representFirstNamePassport: "",
                representGenderId: propertyInfo.customerGender.find(v => v.text == (loginUserInfo.sexCode == "01" ? "男性" : "女性")).value,
                postCode: loginUserInfo.zipCode ? loginUserInfo.zipCode : "",
                address: loginUserInfo.address1 ? loginUserInfo.address1 : "",
                representBirthday: loginUserInfo.birthday ? loginUserInfo.birthday : "1960-01-01",
                telNum: loginUserInfo.mobilePhone ? loginUserInfo.mobilePhone : loginUserInfo.phone ? loginUserInfo.phone : "",
                mail: loginUserInfo.pcAddress ? loginUserInfo.pcAddress : "",
                subMail: loginUserInfo.pcAddress ? loginUserInfo.pcAddress : "",
            }
    );
    const [roomList, setRoomList] = useState([]);
    const [applicationConditionList, setApplicationConditionList] = useState([]);
    const comfirmBackFlg = state.locationInfo && state.locationInfo.pathname.indexOf("userInputConfirm") != -1 ? true : false;
    const domesticFlg = searchParam.searchParam.overseasHomeFlg;
    // プロパティ一覧
    const [paymentMtd, setPaymentMtd] = useState([]);
    const [custmerGender, setCustmerGender] = useState([]);

    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessage: null, errorFlg: false, });
    const [flgList, setFlgList] = useState(false);

    // rtoasterタグ生成
    let totalAdultNum = 0;
    let totalChildNum = 0;
    let totalChildAgeList = [];
    stayInfo.forEach(value => {
        totalAdultNum += Number(value.adultNum);
        totalChildNum += Number(value.childNum);
        if (value.ageList?.length) {
            totalChildAgeList.push(value.ageList.join(","));
        }
    })
    const customParam = {
        "hotelid": toUserInputInfo.hotelId,
        "packcd": toUserInputInfo.planId.split("_")?.[1],
        "roomid": toUserInputInfo.planId.split("_")?.[0],
        "packnam": toUserInputInfo.planName,
        "roomname": toUserInputInfo.roomType,
        "riyosyodat": searchParam.searchParam.startDate,
        "riyosaisyudat": searchParam.searchParam.endDate,
        "roomsu": toUserInputInfo.roomNum,
        "adultninzu": totalAdultNum,
        "childninzu": totalChildNum,
        "childage": totalChildAgeList.length ? totalChildAgeList.join(",") : ""
    }
    useRtoaster(history.location.pathname, customParam);

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
        window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
        // プロパティ一覧取得
        common.doPost(getPropertyList, { propertyTypeList: ["PAYMENT_MET", "CUSTOMER_GENDER"] }, afterGetPropertyList);
        setToUserInputInfo(toUserInputInfo);
        // 一時予約取得
        common.doPost(getTempReserveInfo, { loginId: login.memberCode, reserveId: toUserInputInfo.reserveId }, afterGetTempReserveInfo);
        setLinkList([{ path: "/reserve/top", label: "HOME" }, { path: "/reserve/rtcc/reservation", label: "RTCC予約" }]);
        let room = [];
        if (state.locationInfo && state.locationInfo.pathname.indexOf("userInputConfirm") != -1 && toUserInputConfirmInfo.roomInfo) {
            setRoomList(toUserInputConfirmInfo.roomInfo);
        } else {
            stayInfo.forEach((value, index) => {
                let guestList = [];
                let guestSeq = 0;
                for (let i = 0; i < value.adultNum; i++) {
                    guestList.push({
                        guestSeq: guestSeq + 1,
                        representFlg: false,
                        ageGroupFlg: "adult",
                        ageGroupId: customerAge.find(v => v.value == "大人").id,
                        guestName: "",
                        guestNameKana: "",
                        guestLastNamePassport: "",
                        guestFirstNamePassport: "",
                        guestGenderId: propertyInfo.customerGender.find(v => v.text == "男性").value,
                        guestBirthday: "1960-01-01",
                        address: "",
                        telephoneNumber: "",
                        mailAddress: ""
                    });
                    guestSeq++;
                }
                for (let i = 0; i < value.childNum; i++) {
                    guestList.push({
                        guestSeq: guestSeq + 1,
                        representFlg: false,
                        ageGroupflg: "child",
                        ageGroupId: customerAge.find(v => v.value == "こども").id,
                        guestName: "",
                        guestNameKana: "",
                        guestLastNamePassport: "",
                        guestFirstNamePassport: "",
                        guestGenderId: propertyInfo.customerGender.find(v => v.text == "男性").value,
                        guestBirthday: "1960-01-01",
                        address: "",
                        telephoneNumber: "",
                        mailAddress: ""
                    });
                    guestSeq++;
                }
                let roomObj = {
                    roomCount: index + 1,
                    adultSum: value.adultNum,
                    childSum: value.childNum,
                    childAge: value.ageList && value.ageList.length != 0 ? value.ageList.toString() : "",
                    // childSleepingSum: 0, 添い寝は後のver.で対応
                    guestInfo: guestList
                }
                room.push(roomObj);
            })
            setRoomList(room);
        }
        setToUserInputConfirmInfo(toUserInputConfirmInfo);
        // 約款情報一覧取得
        common.doPost(getClauseList, {}, afterGetClauseList);
    }, [useMediaFlag]);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    const afterGetTempReserveInfo = (res) => {
        const data = res.data;
        if (data && data.resultCode == 38) {
            window.scroll({ top: 0, behavior: 'smooth' });
            setErrorInfo({
                errorMessage: [data.errorMessage],
                errorFlg: true,
                errorCode: data.resultCode
            });
        }else if (data && data.reserve.length == 1) {
            setFeeInfo({totalFee: data.reserve[0].fee, stayInfo: data.reserve[0]?.stayInfo});
        }
    }

    const afterGetClauseList = (res) => {
        if (res.data) {
            let dataList = [];
            if (res.data.clauseList) {
                res.data.clauseList.map((value, index) => {
                    let condition = {
                        id: value.id,
                        type: value.type,
                        contents: value.contents,
                        checked: comfirmBackFlg ? true : false,
                    };
                    dataList.push(condition);
                })
            }
            setApplicationConditionList(domesticFlg ? dataList.filter(value => value.id == "PM00000030" || value.id == "PM00000032" ) : dataList.filter(value => value.id != "PM00000030"));
        } else {
            // エラー処理
        }
    }

    const afterGetPropertyList = (res) => {
        let data = res.data;
        if (data) {
            if (data.propertyInfoList && data.propertyInfoList.length != 0) {
                let propertyInfoList = data.propertyInfoList;
                propertyInfoList.map((value, index) => {
                    let dataList = [];
                    switch (value.propertyType) {
                        case "PAYMENT_MET":
                            value.propertyList.map((property, propertyIndex) => {
                                let obj = {};
                                if (propertyIndex == 0) {
                                    obj = { checked: true, text: property.propertyName, value: property.propertyId };
                                } else {
                                    obj = { checked: false, text: property.propertyName, value: property.propertyId };
                                }
                                dataList.push(obj);
                            })
                            setPaymentMtd(domesticFlg ? dataList.filter(value => value.text != "振込20%") :  dataList);
                            break;
                        default:
                            break;
                    }
                })
            }
        } else {
            // エラー処理
        }
    }

    // 「戻る」ボタン押下時
    const onClickBack = () => {
        history.push("/reserve/rtcc/reservationResult");
    }

    // 「確認画面へ」ボタン押下時
    const onClickCheckInput = () => {
        // 入力チェック
        let flgList = {
            representNameError: false,
            representNameKanaError: false,
            representLastNamePassportError: false,
            representFirstNamePassportError: false,
            representBirthday: false,
            postCodeError: false,
            addressError: false,
            telNumError: false,
            mailError: false,
            subMailError: false,
            errorRoomList: [],
            representErrorFlg: false,
            conditionError: false,
            adultError: false,
            validFlg: false
        };
        let errorMessageBox = [];

        let paymentId = "";
        let paymentOption = document.getElementsByName("paymentOption");
        paymentOption.forEach((value, index) => {
            if (value.checked) {
                paymentId = value.value;
            }
        });
        let representName = document.getElementById("representName").value;
        let representNameKana = document.getElementById("representNameKana").value;
        let representLastNamePassport = document.getElementById("representLastNamePassport").value;
        let representFirstNamePassport = document.getElementById("representFirstNamePassport").value;
        let representGenderId = "";
        let representSex = document.getElementsByName("representSex");
        representSex.forEach((value, index) => {
            if (value.checked) {
                representGenderId = value.value;
            }
        })
        let postCode = document.getElementById("postCode").value;
        let address = document.getElementById("address").value;
        let representYear = document.getElementById("representYear").value;
        let representMonth = document.getElementById("representMonth").value;
        let representDay = document.getElementById("representDay").value;
        let telNum = document.getElementById("telNum").value;
        let mail = document.getElementById("mail").value;
        let subMail = document.getElementById("subMail").value;
        let representInfo = {
            representName: representName,
            representNameKana: representNameKana,
            representLastNamePassport: representLastNamePassport,
            representFirstNamePassport: representFirstNamePassport,
            representGenderId: representGenderId,
            postCode: postCode,
            address: address,
            representBirthday: representYear + "-" + representMonth + "-" + representDay,
            telNum: telNum,
            mail: mail,
            subMail: subMail
        };
        // バリデーションチェック
        if (!CommonValidation.Require(representName) && CommonValidation.Zenkaku(representName)) {
            flgList.validFlg = true;
            flgList.representNameError = true;
        }
        if (!CommonValidation.Require(representNameKana) && CommonValidation.Zenkaku(representNameKana)) {
            flgList.validFlg = true;
            flgList.representNameKanaError = true;
        }
        if (CommonValidation.Require(representLastNamePassport) || CommonValidation.NotAlphaNumAndBlank(representLastNamePassport)) {
            flgList.validFlg = true;
            flgList.representLastNamePassportError = true;
        }
        if (CommonValidation.Require(representFirstNamePassport) || CommonValidation.NotAlphaNumAndBlank(representFirstNamePassport)) {
            flgList.validFlg = true;
            flgList.representFirstNamePassportError = true;
        }
        if (representYear == "0000" || representMonth == "00" || representDay == "00") {
            flgList.validFlg = true;
            flgList.representBirthday = true;
        }
        if (CommonValidation.Require(postCode)) {
            flgList.validFlg = true;
            flgList.postCodeError = true;
        }
        if (CommonValidation.Require(address)) {
            flgList.validFlg = true;
            flgList.addressError = true;
        }
        if (CommonValidation.Require(telNum)) {
            flgList.validFlg = true;
            flgList.telNumError = true;
        }
        if (CommonValidation.Require(mail)) {
            flgList.validFlg = true;
            flgList.mailError = true;
        }
        if (CommonValidation.Require(subMail) || mail != subMail) {
            flgList.validFlg = true;
            flgList.subMailError = true;
        }
        let newRoomList = [...roomList];
        newRoomList.forEach((room, roomIndex) => {
            let errorRoom = {
                erroradultSum: false,
                errorGuestList: []
            };
            if (room.adultSum == 0) {
                flgList.validFlg = true;
                errorRoom.erroradultSum = true;
            }
            room.guestInfo.forEach((guest, guestIndex) => {
                if (guest.representFlg) {
                    guest.guestName = representInfo.representName;
                    guest.guestNameKana = representInfo.representNameKana;
                    guest.guestLastNamePassport = representInfo.representLastNamePassport;
                    guest.guestFirstNamePassport = representInfo.representFirstNamePassport;
                    guest.guestGenderId = representGenderId;
                    guest.guestBirthday = representInfo.representBirthday;
                    guest.address = representInfo.address;
                    guest.telephoneNumber = representInfo.telNum;
                    guest.mailAddress = representInfo.subMail;
                }
                let errorGuest = {
                    errorGuestName: false,
                    errorGuestNameKana: false,
                    errorGuestLastNamePassport: false,
                    errorGuestFirstNamePassport: false,
                    errorGuestBirthday: false,
                    errorAdult: false
                }
                if (!CommonValidation.Require(guest.guestName) && CommonValidation.Zenkaku(guest.guestName)) {
                    flgList.validFlg = true;
                    errorGuest.errorGuestName = true;
                }
                if (!CommonValidation.Require(guest.guestNameKana) && CommonValidation.Zenkaku(guest.guestNameKana)) {
                    flgList.validFlg = true;
                    errorGuest.errorGuestNameKana = true;
                }
                if (CommonValidation.Require(guest.guestLastNamePassport) || CommonValidation.NotAlphaNumAndBlank(guest.guestLastNamePassport)) {
                    flgList.validFlg = true;
                    errorGuest.errorGuestLastNamePassport = true;
                }
                if (CommonValidation.Require(guest.guestFirstNamePassport) || CommonValidation.NotAlphaNumAndBlank(guest.guestFirstNamePassport)) {
                    flgList.validFlg = true;
                    errorGuest.errorGuestFirstNamePassport = true;
                }
                let birthDay = guest.guestBirthday.split("-");
                if (birthDay[0] == "0000" || birthDay[1] == "00" || birthDay[2] == "00") {
                    flgList.validFlg = true;
                    errorGuest.errorGuestBirthday = true;
                } else if (guestIndex == 0) {
                    let checkInDate = new Date(checkIn);
                    if (Math.floor((Number(checkInDate.getFullYear().toString().padStart(4, '0') + (checkInDate.getMonth() + 1).toString().padStart(2, '0') + checkInDate.getDate().toString().padStart(2, '0'))
                        - Number(birthDay[0] + birthDay[1] + birthDay[2])) / 10000) < 21) {
                        if (guest.representFlg) {
                            flgList.representBirthday = true;
                        }
                        flgList.validFlg = true;
                        flgList.adultError = true;
                        errorGuest.errorAdult = true;
                    }
                }
                errorRoom.errorGuestList.push(errorGuest);
            })
            flgList.errorRoomList.push(errorRoom);
        })
        // 代表者選択チェック
        let representErrorFlg = document.getElementsByName("representFlg");
        let representErrorCnt = 0;
        representErrorFlg.forEach((value, index) => {
            if (value.checked) {
                representErrorCnt += 1;
            }
        });
        if (representErrorCnt == 0) {
            flgList.representError = true;
            flgList.validFlg = true;
        }
        // 申込条件チェック
        let conditionList = document.getElementsByName("applicationConditions");
        conditionList.forEach((value, index, array) => {
            if (!array[index].checked) {
                flgList.conditionError = true;
                flgList.validFlg = true;
            }
        });
        setFlgList(flgList);
        if (flgList.validFlg) {
            errorMessageBox.push(MessageConst.INPUT_ERROR);
            if (flgList.representError) {
                errorMessageBox.push(MessageConst.REPRESENT_ERROR);
            }
            if (flgList.conditionError) {
                errorMessageBox.push(MessageConst.CONDITION_ERROR);
            }
            if (flgList.adultError) {
                errorMessageBox.push(MessageConst.ADULT_ERROR);
            }
            setErrorInfo({
                errorMessage: errorMessageBox,
                errorFlg: flgList.validFlg
            });
            window.scroll({ top: 0, behavior: 'smooth' })
        } else {
            setErrorInfo({
                errorMessage: [],
                errorFlg: false
            });
            setToUserInputConfirmInfo({
                hotelId: toUserInputInfo.hotelId,
                hotelName: toUserInputInfo.hotelName,
                planId: toUserInputInfo.planId,
                planName: toUserInputInfo.planName,
                roomTypeName: toUserInputInfo.roomType,
                paymentId: paymentId,
                paymentPrice: toUserInputInfo.planFee,
                roomSum: toUserInputInfo.roomNum,
                representInfo: representInfo,
                roomInfo: newRoomList,
                checkInDate: toUserInputInfo.startDate,
                checkOutDate: toUserInputInfo.endDate,
                reserveId: "",
            });
            setRoomList(newRoomList);
            history.push("/reserve/rtcc/userInputConfirm");
        }
    }

    // 人数入力フォーム変更処理 後のver.で使用
    // const handleHumanNum = (id, roomIndex) => {
    //     let room = [];
    //     for (let i = 0; i < roomNum; i++) {
    //         let adult = Number(document.getElementById("adult" + i).value);
    //         let child = Number(document.getElementById("child" + i).value);
    //         // let share = Number(document.getElementById("share" + i).value);
    //         let gusetNumSrc = roomList[i].guestInfo.length;
    //         let gusetNum = adult + child + share;
    //         let addNum = gusetNum - gusetNumSrc;
    //         let guestList = roomList[i].guestInfo;
    //         if (addNum < 0) {
    //             guestList = roomList[i].guestInfo.filter((value, guestIndex) => {
    //                 return guestIndex < gusetNum;
    //             })
    //         } else {
    //             for (let j = 0; j < addNum; j++) {
    //                 guestList.push({
    //                     guestSeq: guestList.length + j + 1,
    //                     representFlg: false,
    //                     ageGroupId: "PM00000023",
    //                     guestName: "",
    //                     guestNameKana: "",
    //                     guestLastNamePassport: "",
    //                     guestFirstNamePassport: "",
    //                     guestGenderId: "PM00000026",
    //                     guestBirthday: "0000-00-00",
    //                     address: "",
    //                     telephoneNumber: "",
    //                     mailAddress: ""
    //                 });
    //             }
    //         }
    //         let roomObj = {
    //             roomCount: i + 1,
    //             adultSum: adult,
    //             childSum: child,
    //             // childSleepingSum: share,
    //             guestInfo: guestList
    //         }
    //         room.push(roomObj);
    //     }
    //     setRoomList(room);
    // }

    // 代表者情報入力
    const handleRepresentInfo = (form) => {
        let input = document.getElementById(form).value;
        setRepresentInfo({ ...representInfo, [form]: input });
    }
    // 代表者性別変更
    const handleRepresentGenderInfo = () => {
        let input = "";
        let representSex = document.getElementsByName("representSex");
        representSex.forEach((value, index) => {
            if (value.checked) {
                input = value.value;
            }
        });
        setRepresentInfo({ ...representInfo, representGenderId: input });
    }
    // 代表者生年月日変更
    const handleRepresentBirthdayInfo = () => {
        let representYear = document.getElementById("representYear").value;
        let representMonth = document.getElementById("representMonth").value;
        let representDay = document.getElementById("representDay").value;
        setRepresentInfo({ ...representInfo, representBirthday: representYear + "-" + representMonth + "-" + representDay });
    }
    // 宿泊者情報入力
    const handleGuestInfo = (form, roomIndex, guestIndex) => {
        let input = document.getElementById(form + roomIndex + "_" + guestIndex).value;
        let newList = [];
        roomList[roomIndex]["guestInfo"][guestIndex][form] = input;
        roomList.map((value) => {
            newList.push(value)
        })
        setRoomList(newList);
    }
    // 宿泊者性別変更
    const handleGuestGenderInfo = (roomIndex, guestIndex) => {
        let input = "";
        let guestGenderId = document.getElementsByName("guestGenderId" + roomIndex + "_" + guestIndex);
        guestGenderId.forEach((value, index) => {
            if (value.checked) {
                input = value.value;
            }
        });
        let newList = [];
        roomList[roomIndex]["guestInfo"][guestIndex]["guestGenderId"] = input;
        roomList.map((value) => {
            newList.push(value)
        })
        setRoomList(newList);
    }
    // 宿泊者生年月日変更
    const handleGuestBirthdayInfo = (roomIndex, guestIndex) => {
        let year = document.getElementById("guestYear" + roomIndex + "_" + guestIndex).value;
        let month = document.getElementById("guestMonth" + roomIndex + "_" + guestIndex).value;
        let day = document.getElementById("guestDay" + roomIndex + "_" + guestIndex).value;
        let newList = [];
        roomList[roomIndex]["guestInfo"][guestIndex]["guestBirthday"] = year + "-" + month + "-" + day;
        roomList.map((value) => {
            newList.push(value)
        })
        setRoomList(newList);
    }

    // 代表者フラグ設定
    const handleRepresentFlg = (roomIndex) => {
        let representSex = document.getElementsByName("representSex");
        let newList = [];
        roomList.map((room, i) => {
            let guestSex = document.getElementsByName("guestGenderId" + i + "_" + 0);
            let guestObj = {
                guestSeq: 1,
                representFlg: false,
                ageGroupFlg: "adult",
                ageGroupId: customerAge.find(v => v.value == "大人").id,
                guestName: "",
                guestNameKana: "",
                guestLastNamePassport: "",
                guestFirstNamePassport: "",
                guestGenderId: propertyInfo.customerGender.find(v => v.text == "男性").value,
                guestBirthday: "1960-01-01",
                address: "",
                telephoneNumber: "",
                mailAddress: ""
            };
            let guestGenderId = "";
            if (i == roomIndex) {
                representSex.forEach((value, sexIndex) => {
                    if (value.checked) {
                        guestGenderId = value.value;
                        guestSex[sexIndex].checked = true;
                    }
                });
                guestObj = {
                    guestSeq: 1,
                    representFlg: true,
                    ageGroupFlg: room.guestInfo[0].ageGroupFlg,
                    ageGroupId: room.guestInfo[0].ageGroupId,
                    guestName: representInfo.representName,
                    guestNameKana: representInfo.representNameKana,
                    guestLastNamePassport: representInfo.representLastNamePassport,
                    guestFirstNamePassport: representInfo.representFirstNamePassport,
                    guestGenderId: guestGenderId,
                    guestBirthday: representInfo.representBirthday,
                    address: representInfo.address,
                    telephoneNumber: representInfo.telNum,
                    mailAddress: representInfo.subMail
                };
                roomList[roomIndex]["guestInfo"][0] = guestObj;
            } else {
                // if (room.adultSum != 0 || room.childSum != 0 || room.childSleepingSum != 0) {
                if (room.adultSum != 0 || room.childSum != 0) {
                    guestSex[0].checked = true;
                }
                roomList[i]["guestInfo"][0] = guestObj;
            }
            newList.push(room)
        })
        setRoomList(newList);
    }

    // 「すべて確認して同意」ボタン押下
    const onClickAllAccept = () => {
        let conditionList = document.getElementsByName("applicationConditions");
        conditionList.forEach((value, index, array) => {
            array[index].checked = true;
        });
    }

    return (
        <div className="userInputInnerWrapper">
            <BreadCrumb
                breadCrumbStyle={isWideTablet ? { display: "none" } : styles.breadCrumb}
                linkStyle={styles.link}
                linkList={linkList}
                lastLabel="お客様情報入力"
                lastLabelClassName="lastLabel"
            />
            <div style={isWideTablet ? styles.breadCrumb2 : { display: "none" }}></div>
            <div className="userInputWrapper">
                <div className="userInput">
                    <div className={"stayInfo"} style={styles.userInput}>
                        <div style={errorInfo.errorFlg ? styles.errorDiv : { display: "none" }}>
                            <ErrorMassage style={styles.errorMassage} data={errorInfo.errorMessage} />
                        </div>
                        <Label
                            label={"宿泊情報"}
                            className="titleLabel"
                        />
                        <div className="roonNumArea">
                            <Label label={"部屋数"} className="inputTitleLabel2" />
                            <Label label={roomNum ? roomNum + "室" : 0 + "室"} className="roomNumLabel" />
                        </div>
                        {/* 人数入力フォーム */}
                        <HumanInputForm
                            human={human}
                            roomNum={roomNum}
                            roomList={roomList}
                            // onChange={handleHumanNum}
                            flgList={flgList}
                        />
                        <div style={styles.fee}>
                            <Label
                                className="inputTitleLabel2"
                                label={"お支払い旅行代金"}
                            />
                            {feeInfo?.stayInfo?.length ?
                                <div className="rtccPriceWrapper">
                                    {feeInfo?.stayInfo?.map(value =>
                                        <div>
                                            <Label
                                                className="inputTitleLabel2"
                                                label={value.roomCount + "室目"}
                                            />
                                            {value.feeList?.map(feeObj =>
                                                <div className="rtccPriceFlex">
                                                    <Label
                                                        className="inputTitleLabel2"
                                                        label={commonUtil.getStringFromDateJpnRtcc(feeObj.stayDate)}
                                                    />
                                                    <Label
                                                        className="inputTitleLabel2"
                                                        label={"：￥" + feeObj.dayFee?.toLocaleString()}
                                                    />
                                                </div>
                                            )}
                                            <Label
                                                className="userFeeRikisha"
                                                label={"小計：￥" + value.roomFee?.toLocaleString()}
                                            />
                                        </div>
                                    )
                                    }
                                    <Label
                                        className="userFeeRikisha"
                                        label={feeInfo?.totalFee ? "合計：￥" + feeInfo.totalFee.toLocaleString() : "合計：¥0 "}
                                    />
                                </div>
                                :
                                <Label
                                    className="userFeeHawaii"
                                    label={feeInfo?.totalFee ? "￥" + feeInfo.totalFee.toLocaleString() : "¥0 "}
                                />
                            }
                        </div>
                        <RadioButtonForm
                            data={state.locationInfo && state.locationInfo.pathname.indexOf("userInputConfirm") != -1 &&
                                toUserInputConfirmInfo.paymentId ? paymentMtd.map(value => ({
                                    checked: value.value == toUserInputConfirmInfo.paymentId,
                                    text: value.text,
                                    value: value.value
                                })) : paymentMtd}
                            id={"paymentOption"}
                            style={{ display: "flex", flexWrap: "wrap" }}
                            name="paymentOption"
                            label={"お支払い方法"}
                            wrapClassName="paymentOptionWrap"
                            titleClassName="paymentOptionTitleLabel"
                            inputClassName="onlyPlanRadio"
                            labelClassName="paymentOptionLabel"
                        />
                    </div>
                </div>
            </div>
            {/* 部屋情報入力フォーム */}
            <RoomInputList
                roomList={roomList}
                gender={propertyInfo.customerGender}
                humanType={customerAge}
                id={props.id}
                titleClassName="titleLabel"
                representFlg={false}
                represent={represent}
                representInfo={representInfo}
                handleGuestInfo={handleGuestInfo}
                handleGuestGenderInfo={handleGuestGenderInfo}
                handleGuestBirthdayInfo={handleGuestBirthdayInfo}
                handleRepresentInfo={handleRepresentInfo}
                handleRepresentGenderInfo={handleRepresentGenderInfo}
                handleRepresentBirthdayInfo={handleRepresentBirthdayInfo}
                handleRepresentFlg={handleRepresentFlg}
                flgList={flgList}
                responsiveFlg={isWideTablet}
            />
            <div className="userInputConditionWrapper">
                <Label label="お申し込みに関する条件" className="conditionTitleLabel" />
                <Label
                    label={"以下の内容を必ずお読みいただき、「すべて確認して同意」にチェックした後、「確認画面へ」のボタンを押下してください。" +
                        "\n" + "各規約の内容は規約の名称をクリックして頂くと表示されます。"}
                    className="confirmText"
                />
                <AcceptForm
                    data={applicationConditionList}
                    id="applicationConditions"
                    name="applicationConditions"
                    endLabel={domesticFlg ? " に同意します" : " の内容を理解しました"}
                    endLabelStyle={styles.endLabel}
                    conditionLabelStyle={styles.conditionLabel}
                    onClick={onClickOpenReservationPopupWindow}
                    checkBoxClassName="conditionCheckList"
                />
                <Label label="これまでの「お申込み内容」、および以下項目を必ずご確認ください。" className="confirmText2" />
                <Label
                    label="旅行契約にあたり、取引条件説明書面（上述の契約内容と旅行条件書の内容が記載された書面）については、
                    契約成立後に予約確認を参照することにより「書面の交付」に代えることに同意されますか。"
                    className="confirmText2"
                />
                <Label
                    label="運送・宿泊機関、保険会社などへ旅行手配のために必要な範囲内での個人情報の提供について同意されますか。"
                    className="confirmText"
                />
                <div style={styles.allConfirmbox}>
                    <Button buttonText="すべて確認して同意" className="btnAllConfirm" onClick={onClickAllAccept} buttonClassName="serachBtnText" />
                </div>
                <Line style={styles.hr} />
            </div>
            <div className="btnToReserveConfirmWrapper">
                <div class="confirmboxWrap">
                    <Button buttonText="戻る" className="btnBack btnSpStyle"  onClick={onClickBack} buttonClassName="serachBtnText" />
                    <Button buttonText="確認画面へ" className="btnToConfirm btnSpStyle2" onClick={onClickCheckInput} buttonClassName="serachBtnText" />
                </div>
            </div>
            <div className={isWideTablet ? "reserveConirmWrapperWide" : "reserveConirmWrapper"}>
                <div className="userInput3">
                    <Label label="ご予約内容" className="reserveConirmTitle" />
                    <div className={"reservationContentsWrap"}>
                        <div className="reservationContents">
                            <Label
                                label="施設名"
                                className={isWidePhone ? "inputTitleLabelNarrow" : "inputTitleLabel"}
                            />
                            <Label
                                label={toUserInputInfo.hotelName}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                        <div className="reservationContents">
                            <Label
                                label="宿泊プラン名"
                                className={isWidePhone ? "inputTitleLabelNarrow" : "inputTitleLabel"}
                            />
                            <Label
                                label={toUserInputInfo.planName}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                        <div className="reservationContents">
                            <Label
                                label="ご利用日程"
                                className={isWidePhone ? "inputTitleLabelNarrow" : "inputTitleLabel"}
                            />
                            <Label
                                label={toUserInputInfo.startDate + "\n" + "～" + "\n" + toUserInputInfo.endDate}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                        <div className="reservationContents">
                            <Label
                                label="お部屋タイプ"
                                className={isWidePhone ? "inputTitleLabelNarrow" : "inputTitleLabel"}
                            />
                            <Label
                                label={toUserInputInfo.roomType}
                                className="rtcc_inputContentLabel"
                            />
                        </div>
                        <div className={toUserInputInfo.cancelDescriptions ? "reservationContents" : "hiddenItem"}>
                            <Label
                                label="取消料"
                                className={isWidePhone ? "inputTitleLabelNarrow" : "inputTitleLabel"}
                            />
                            <div className="rtcc_inputContentLabel">
                            <Label
                                label={MessageConst.CANCEL_DESCRIPTION_MESSAGE}
                                className="rtcc_inputContentLabel"
                            />
                            <Label
                                label={toUserInputInfo.cancelDescriptions}
                                className="rtcc_inputContentLabel"
                            />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="rtccBackTop">
                <Link to={"/reserve/rtcc/reservation"} style={styles.bottomLink}>RTCC検索TOPへ戻る</Link>
            </div>
            <div style={styles.footer}>
                <FooterContainer className={"reservationResultFooterBase"} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        login: state.login,
        checkIn: state.checkIn,
        checkOut: state.checkOut,
        group: state.group,
        room: state.room,
        human: state.human,
        course: state.course,
        detailCondition: state.detailCondition,
        startTime: state.startTime,
        login: state.login,
        kaiinken: state.kaiinken,
        area: state.area,
        country: state.country,
        city: state.city,
        searchParam: state.searchParam,
        toUserInputInfo: state.toUserInputInfo,
        toUserInputConfirmInfo: state.toUserInputConfirmInfo,
        customerAge: state.customerAge,
        propertyInfo: state.propertyInfo,
        feeInfo: state.feeInfo,
        stayInfo: state.stayInfo,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setDetailCondition: (item) => {
            dispatch({ type: "DETAIL_CONDITION", payload: { detailCondition: item } })
        },
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setStartTime: (item) => {
            dispatch({ type: "START_TIME", payload: { startTime: item } })
        },
        setGroup: (item) => {
            dispatch({ type: "GROUP", payload: { group: item } })
        },
        setRoom: (item) => {
            dispatch({ type: "ROOM", payload: { room: item } })
        },
        setHuman: (item) => {
            dispatch({ type: "HUMAN", payload: { human: item } })
        },
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setKaiinken: (item) => {
            dispatch({ type: "KAIINKEN", payload: { kaiinken: item } })
        },
        setArea: (item) => {
            dispatch({ type: "AREA", payload: { area: item } })
        },
        setCountry: (item) => {
            dispatch({ type: "COUNTRY", payload: { country: item } })
        },
        setCity: (item) => {
            dispatch({ type: "CITY", payload: { city: item } })
        },
        setCheckIn: (item) => {
            dispatch({ type: "CHECKIN", payload: { checkIn: item } })
        },
        setCheckOut: (item) => {
            dispatch({ type: "CHECKOUT", payload: { checkOut: item } })
        },
        setToUserInputInfo: (item) => {
            dispatch({ type: "TO_USERINPUT_INFO", payload: { toUserInputInfo: item } })
        },
        setToUserInputConfirmInfo: (item) => {
            dispatch({ type: "TO_USERINPUTCONFIRM_INFO", payload: { toUserInputConfirmInfo: item } })
        },
        setFeeInfo: (item) => {
            dispatch({ type: "FEE_INFO", payload: { feeInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(RtccUserInputContainer);

const styles = {
    firstRoomWrapper: {
        width: "80%",
        margin: "0px auto",
        backgroundColor: "#808080",
        padding: "10px 10% 10px 10%",
    },
    userInput: {
        display: "block",
        flexWrap: "wrap",
    },
    roomNum: {
        display: "flex",
        padding: "30px 0px 10px 0px",
        justifyContent: "space-between",
        borderBottom: "1px solid rgb(204, 204, 204);",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    bottomLinkArea: {
        marginTop: "30px",
        paddingTop: "40px",
        textAlign: "center",
        borderTop: "1px solid rgb(204, 204, 204);",
    },
    bottomLink: {
        padding: "3px",
        color: "#696969",
        fontSize: "small",
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        padding: "8px 0px 30px 0px",
    },
    breadCrumb2: {
        marginBottom: "30px",
    },
    breadCrumbArrow: {
        marginRight: "5px",
        marginLeft: "5px",
        marginTop: "1px",
        fontSize: "small",
    },
    genderWrap: {
        marginBottom: "20px",
    },
    gender: {
        display: "flex",
    },
    genderLabel: {
        margin: "0px 30px 0px 10px",
    },
    confirmbox: {
        width: "100%",
        display: "flex",
        borderTop: "1px solid rgb(191, 190, 197)",
        borderBotttom: "1px solid rgb(191, 190, 197)",
        padding: "30px 0px",
    },
    allConfirmbox: {
        width: "100%",
        display: "flex",
        padding: "0px 0px",
        marginBottom: "50px",
    },
    paymentOption: {
        display: "flex",
        marginTop: "20px",
    },
    fee: {
        padding: "10px 0px 15px 0px",
        display: "flex",
        justifyContent: "space-between",
        borderBottom: "1px solid rgb(191, 190, 197)",
    },
    pullDownArea: {
        display: "flex",
        alignItems: "center"
    },
    reservationInfo: {
        display: "flex",
        justifyContent: "space-between",
        margin: "20px 60px 20px 100px",
    },
    endLabel: {
        fontSize: "small",
        padding: "7px 0px 0px 10px",
        color: "rgb(43, 43, 43)",
    },
    conditionLabel: {
        fontSize: "small",
        textDecoration: "underline",
        padding: "7px 0px 0px 0px",
        fontWeight: "bold",
        cursor: "pointer",
    },
    errorMassage: {
        display: "inline-block",
        textAlign: "left",
        padding: "15px 0px 0px 0px",
    },
    errorMassage2: {
        display: "inline-block",
        textAlign: "left",
        padding: "0px 0px 0px 0px",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold"
    },
    errorDiv2: {
        display: "block",
    },
    hr: {
        height: "1px",
        border: "none",
        padding: "0px",
        borderBottom: "1px solid rgb(191, 190, 197)",
    },
    hr2: {
        height: "1px",
        border: "none",
        padding: "0px",
        borderBottom: "1px solid rgb(191, 190, 197)",
        marginTop: "50px",
    },
    hr3: {
        height: "1px",
        border: "none",
        padding: "0px",
        borderBottom: "1px solid rgb(191, 190, 197)",
        margin: "0px"
    },
}